import { render, staticRenderFns } from "./downlists.vue?vue&type=template&id=a5b2e15a&scoped=true"
import script from "./downlists.vue?vue&type=script&lang=js"
export * from "./downlists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b2e15a",
  null
  
)

export default component.exports